import React from 'react';

const sourceLabels = {
  'Direkte / Ingen': 'Direkte / Ingen',
  'google.com': 'Google',
  'www.google.com': 'Google',
  'google.no': 'Google',
  'www.google.no': 'Google',
  'facebook.com': 'Facebook',
  'www.facebook.com': 'Facebook',
  'l.facebook.com': 'Facebook',
  'instagram.com': 'Instagram',
  'www.instagram.com': 'Instagram',
  't.co': 'Twitter/X',
  'linkedin.com': 'LinkedIn',
  'www.linkedin.com': 'LinkedIn',
};

function formatSource(source) {
  return sourceLabels[source] || source;
}

export default function Sources({ data, loading }) {
  if (loading) {
    return (
      <div className="bg-white rounded-xl border border-gray-100 p-5 shadow-sm">
        <h3 className="text-sm font-semibold text-gray-500 uppercase tracking-wider mb-4">Trafikkilder</h3>
        <div className="text-gray-400 text-sm py-8 text-center">Laster...</div>
      </div>
    );
  }

  // Merge duplicate sources after label normalization
  const merged = {};
  (data || []).forEach(({ source, visitors }) => {
    const label = formatSource(source);
    merged[label] = (merged[label] || 0) + visitors;
  });
  const items = Object.entries(merged)
    .map(([source, visitors]) => ({ source, visitors }))
    .sort((a, b) => b.visitors - a.visitors);

  const maxVisitors = items[0]?.visitors || 1;

  return (
    <div className="bg-white rounded-xl border border-gray-100 p-5 shadow-sm">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-sm font-semibold text-gray-500 uppercase tracking-wider">Trafikkilder</h3>
        <span className="text-xs text-gray-400">Besøkende</span>
      </div>

      {items.length === 0 ? (
        <div className="text-gray-400 text-sm py-8 text-center">Ingen data ennå</div>
      ) : (
        <div className="space-y-2">
          {items.map((item, i) => (
            <div key={i} className="relative">
              <div
                className="absolute inset-y-0 left-0 bg-blue-50 rounded"
                style={{ width: `${(item.visitors / maxVisitors) * 100}%` }}
              />
              <div className="relative flex items-center justify-between px-3 py-2">
                <span className="text-sm text-gray-700">{item.source}</span>
                <span className="text-sm font-semibold text-gray-900">{item.visitors.toLocaleString('nb-NO')}</span>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
